<template>
  <div class="col-sm-6 col-md-4 pad_c">
    <div class="append_next_btn">
      <button class="btn hf-btn-info btn_w_f btn-lg" data-toggle="modal" :data-target="'#campaign_schedule_'+index"><i class="fas fa-plus mr-2"></i>Next</button>
    </div>
    <div class="modal delete_modal fade slide-up disable-scroll" :id="'campaign_schedule_'+index" tabindex="-1" role="dialog" aria-hidden="false">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content-wrapper">
          <div class="modal-content">
            <div class="modal-header modal_header bg-transparent" >
              <span class="fs-18">Schedule A Campaign or Learning</span>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body modal_body">
              <div class="form-group between_input">
                <span>Schedule Campaign After Main </span>
                <input type="number" min="1" v-model='sendAfter' name="" class="datepicker_component">
                <select class="form-control arrow_d" v-model='sendAfterType' data-init-plugin="cs-select" style="width: 80px!important;">
                  <option value="1" selected="selected">Days</option>
                  <option value="2">Hours</option>
                </select>
                <span v-show="sendAfterError" class="text-danger">
                  {{ sendAfterError }}
                </span>
              </div>
              <div class="form-group">
                <strong>Recommended : </strong>with in 7 days of campaign. 
              </div>
              <div class="form-group mb10">
                <div class="fs-14 mb5">Run this campaign on those </div>
                <label class="label_uc">Select Action</label>
                <el-select v-model="campaignAction" multiple placeholder="Select" class="hf_email_select">
                  <el-option v-for="item in actionArry" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <span v-show="campaignActionError" class="text-danger">
                  {{ campaignActionError }}
                </span>
                <span v-if="dateconflicterrormessage==true" class='text-danger'> {{ $t("campaign.bulk_campaign.error_in_date_conflict") }} </span>
              </div>
            </div>
            <div class="modal-footer px-2 py-2">
              <button type="button" class="btn hf-btn-info btn_w" @click='updateCampaignSchedule(campaign.id,index)'>Save and Proceed</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    data() {
        return {
            sendAfter: '',
            sendAfterType: 1,
            campaignAction: [],
            sendAfterError: '',
            campaignActionError: '',
            dateconflicterrormessage: false,
            actionArry: [{
                label: 'All',
                value: 5
            },{
                label: 'Didn\'t Open',
                value: 1
            },
            {
                label: 'Didn\'t Click',
                value: 2
            },
            {
                label: 'Got Lured',
                value: 3
            },
            {
                label: 'Education Not Taken',
                value: 4
            }],
        }
    },
    props: ['campaign', 'index'],
    beforeMount() {
        let campaignsDetails = JSON.parse(JSON.stringify(this.$parent.campaigns)); 
        _.map(campaignsDetails,(t)=>{
            if(t.childCampaign ) {
                if(t.childCampaign.id == this.campaign.id) {
                    
                    if(t.scenario.type === 'announcement') {
                        // User can only select all in this campaign
                        this.actionArry = [{
                            label: 'All',
                            value: 5
                        }];
                    }
                } else if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.id == this.campaign.id) {
                    
                    if(t.childCampaign.scenario.type === 'announcement') {
                        // User can only select all in this campaign
                        this.actionArry = [{
                            label: 'All',
                            value: 5
                        }];
                    }
                }
            }
        });
    },
    methods: {
        updateCampaignSchedule(id,index) {
            this.sendAfterError = "";
            this.campaignActionError = "";

            if (!this.sendAfter || this.sendAfter < 1) {
                this.sendAfterError = "Please enter valid value in send after.";
            }
            if (this.campaignAction == "") {
                this.campaignActionError = "Please select atleast 1 action.";
            }
            if (this.campaignActionError == "" && this.sendAfterError == "") {
                // code to check dates are conflict or not
                let campaignsDetails = JSON.parse(JSON.stringify(this.$parent.campaigns)); 
                let send_at;
                let campaign_id;
                this.dateconflicterrormessage =false;
                _.map(campaignsDetails,(t)=>{
                    if(t.childCampaign ) {
                        if(t.childCampaign.id == id) {
                            t.childCampaign.send_after = this.sendAfter; 
                            t.childCampaign.send_after_type = this.sendAfterType;

                            campaign_id = t.id;  
                            send_at = t.send_at;
                        } else if(t.childCampaign.childCampaign) {
                            if(t.childCampaign.childCampaign.id == id) {
                                t.childCampaign.childCampaign.send_after = this.sendAfter;
                                t.childCampaign.childCampaign.send_after_type = this.sendAfterType;
                                campaign_id = t.id;  
                                send_at = t.send_at;
                            }
                        }
                    }
                });

                var send_at_end;
                _.map(campaignsDetails,(t)=>{
                    if(t.id == campaign_id) {
                        let add_days = parseInt(t.end_days);
                        let add_hours = 0;
                        if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
                        
                            if(t.childCampaign.send_after_type == 1) {
                                add_days += parseInt(t.childCampaign.send_after);
                            } else {
                                add_hours += parseInt(t.childCampaign.send_after);
                            }
                            add_days += parseInt(t.childCampaign.end_days);
                        
                            if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
                            ) {
                                    if(t.childCampaign.childCampaign.send_after_type == 1) {
                                        add_days += parseInt(t.childCampaign.childCampaign.send_after);
                                    } else {
                                        add_hours += parseInt(t.childCampaign.childCampaign.send_after);
                                    }
                                    add_days += parseInt(t.childCampaign.childCampaign.end_days);
                            }
                        }
                        send_at_end = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours').format('Y-MM-DD HH:mm:ss');
                    }
                });

                _.map(campaignsDetails,(t)=>{
                    if(t.id != campaign_id) {
                        let beforeTime = this.moment(t.send_at);
                        let add_days = parseInt(t.end_days);
                        let add_hours = 0;
                        if(t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type
                        ) {
                            if(t.childCampaign.send_after_type == 1) {
                                add_days += parseInt(t.childCampaign.send_after);
                            } else {
                                add_hours += parseInt(t.childCampaign.send_after);
                            }
                            add_days += parseInt(t.childCampaign.end_days);

                            if(t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type
                            ) {
                                if(t.childCampaign.childCampaign.send_after_type == 1) {
                                    add_days += parseInt(t.childCampaign.childCampaign.send_after);
                                } else {
                                    add_hours += parseInt(t.childCampaign.childCampaign.send_after);
                                }
                                add_days += parseInt(t.childCampaign.childCampaign.end_days);
                            }
                        }

                        let afterTime = this.moment(t.send_at).add(add_days,'day').add(add_hours,'hours');
                        if (this.moment(send_at_end).isBetween(beforeTime, afterTime)) {
                            this.dateconflicterrormessage = true;
                            return;
                        }
                    }
                });
                
                if(this.dateconflicterrormessage == true){
                    return false;
                } else {
                    let data =
                        {
                            send_after: this.sendAfter,
                            send_after_type: this.sendAfterType,
                            action: this.campaignAction,
                            id: id
                        }
                    this.$http.post('/bulk/campaign/schedulecampaign/bulkedit', data).then((response) => {
                        // this.$parent.getScenarioDetail();
                        $('#campaign_schedule_'+index).modal('hide');
                        this.$parent.$emit('showUpdateSuccessFullMesssage');
                        this.$parent.getCampaignById(id);
                    });
                }
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// nextButtonCard.vue?781418ad